export default __webpack_public_path__ + "static/char-s-36-en-f1181e9a1283f2319ef8a7fba0459067.png";